import LenderWithdrawals from "./LenderWithdrawals.jsx";

export default LenderWithdrawals;
